import {ActionPromptEnum} from "../../interfaces/enums";

export const voucherStatusMap: IDynamicFields = {
  "INITIATED": {
    label: "Initiated",
    fill: "bg-success",
  },
  "PREPARED": {
    label: "Prepared",
    fill: "bg-success",
  },
  "APPROVED": {
    id: 3,
    label: "Approved",
    fill: "bg-success"
  },
  "RECEIVED": {
    id: 4,
    label: "Received",
    fill: "bg-success"
  },
  "PAID": {
    id: 5,
    label: "Paid",
    fill: "bg-success"
  },
  "REJECTED": {
    id: 3,
    label: "Rejected",
    fill: "bg-danger",
  },
}

export const LoanRequestMap: IDynamicFields = {
  "DISBURSED": {
    label: "Disbursed",
    fill: "bg-primary",
  },
  "PROCESSING": {
    label: "Processing",
    fill: "bg-warning",
  },
  "REPAYMENT": {
    label: "Processing",
    fill: "bg-info",
  },
  "REJECTED": {
    id: 3,
    label: "Rejected",
    fill: "bg-danger"
  },
  "COMPLETED": {
    id: 3,
    label: "Completed",
    fill: "bg-success"
  }
}

export const QuickPayRequestMap: IDynamicFields = {
  "INITIATED": {
    label: "Initiated",
    fill: "bg-primary",
  },
  "PENDING": {
    label: "Pending",
    fill: "bg-warning",
  },
  "REPAYMENT": {
    label: "Processing",
    fill: "bg-info",
  },
  "REJECT": {
    id: 3,
    label: "Rejected",
    fill: "bg-danger"
  },
  "REJECTED": {
    id: 4,
    label: "Rejected",
    fill: "bg-danger"
  },
  "APPROVE": {
    id: 5,
    label: "Approved",
    fill: "bg-success"
  },
  "APPROVED": {
    id: 6,
    label: "Approved",
    fill: "bg-success"
  }
}

export const orgFlowMap: IDynamicFields = {
  "DEMAND_FLOW": {
    label: "Demand Services",
    fill: "bg-success",
  },
  "SUPPLY_FLOW": {
    label: "Supply Services",
    fill: "bg-success",
  },
  "DEMAND_SUPPLY_FLOW": {
    id: 3,
    label: "Demand and Supply Services",
    fill: "bg-success"
  }
}

export const ActionPromptMap = {
  [ActionPromptEnum.APPROVE_TOP_UP_REQUEST]: {
    id: 1,
    title: "Approve Top-Up Request",
    placeholder: "Type in the top-up request reference",
    message: "You are going to approve this top-up request with reference",
    actionText: "Yes, Approve Request",
    successMessage: "You’ve approved this quick top-up request",
  },
  [ActionPromptEnum.REJECT_TOP_UP_REQUEST]: {
    id: 2,
    title: "Deny Top-Up Request",
    placeholder: "Type in the top-up request reference",
    message: "You are going to reject this top-up request with reference",
    actionText: "Yes, Deny Request",
    successMessage: "You’ve successfully rejected this quick top-up request",
  },
  [ActionPromptEnum.REPAY_PARTIAL_TOP_UP_REQUEST]: {
    id: 3,
    title: "Repay Partial Top-Up Request",
    placeholder: "Type in the top-up request reference",
    message: "You are going to make a partial repayment of this quick top-up request with reference",
    actionText: "Yes, Repay Partial Top-Up Request",
    successMessage: "You’ve successfully repaid this quick top-up request",
  },
  [ActionPromptEnum.REPAY_COMPLETE_TOP_UP_REQUEST]: {
    id: 4,
    title: "Repay Complete Top-Up Request",
    placeholder: "Type in the top-up request reference",
    message: "You are going to make a complete repayment of this quick top-up request with reference",
    actionText: "Yes, Repay Complete Top-Up Request",
    successMessage: "You’ve successfully repaid this quick top-up request",
  },
  [ActionPromptEnum.APPROVE_QUICK_PAY_REQUEST]: {
    id: 5,
    title: "Approve Quick-Pay Request",
    placeholder: "Type in your comment",
    message: "You are going to approve this quick-pay request",
    actionText: "Yes, Aprove Quick Pay Request",
    successMessage: "You’ve successfully approved this quick-pay request",
  },
  [ActionPromptEnum.REJECT_QUICK_PAY_REQUEST]: {
    id: 6,
    title: "Reject Quick-Pay Request",
    placeholder: "Type in your comment",
    message: "You are going to reject this quick-pay request",
    actionText: "Yes, Reject Quick Pay Request",
    successMessage: "You’ve successfully rejected this quick-pay request",
  },
  [ActionPromptEnum.REFUND_ADVANCED_PAYMENT_REQUEST]: {
    id: 7,
    title: "Refund Advanced Payment Request",
    placeholder: "Type in the amount",
    message: "You are going to refund this advance payment request",
    actionText: "Yes, Refund Advanced Payment Request",
    successMessage: "You’ve successfully refunded this advanced payment request",
  },
}

